import { aspectRatios } from '@/components/ui/image-size';
import { LoraModel } from '@/types/lora';

export interface SavedSettings {
  aspectRatio: (typeof aspectRatios)[0];
  loraModel: LoraModel | null;
}

export const getStoredSettings = (productId: string): SavedSettings | null => {
  try {
    const saved = localStorage.getItem(`product-${productId}-settings`);
    if (!saved) return null;

    const settings: SavedSettings = JSON.parse(saved);
    const validRatio = aspectRatios.find(
      (ratio) => ratio.value === settings.aspectRatio.value
    );
    if (!validRatio) return null;

    return {
      aspectRatio: validRatio,
      loraModel: settings.loraModel,
    };
  } catch (error) {
    console.error('Error loading settings:', error);
    return null;
  }
};

export const saveSettings = (productId: string, settings: SavedSettings) => {
  try {
    localStorage.setItem(
      `product-${productId}-settings`,
      JSON.stringify(settings)
    );
  } catch (error) {
    console.error('Error saving settings:', error);
  }
}; 